import { useState } from 'react'

import {
  Dialog,
  RadioGroup,
  Radio,
  TextField,
  Text,
  Layout,
  type RadioGroupChangeEventDetail,
} from '@loadsmart/miranda-react'

const radioValues = [
  'There’s not enough shipment information',
  'I don’t have capacity available',
  'The pickup date is too close',
  'Other',
] as const

type ConfirmRejectDialogProps = Readonly<{
  open: boolean
  onConfirm: (reason: string) => void
  onCancel: () => void
}>

function ConfirmRejectDialog({ open, onConfirm, onCancel }: ConfirmRejectDialogProps) {
  const [rejectReason, setRejectReason] = useState<string>(radioValues[0])
  const [otherReason, setOtherReason] = useState<string>('')

  function handleChange({ detail }: CustomEvent<RadioGroupChangeEventDetail>) {
    setRejectReason(detail.value)
  }

  function handleConfirm() {
    if (rejectReason === 'Other') {
      onConfirm(otherReason)
    } else {
      onConfirm(rejectReason)
    }
  }
  return (
    <Dialog open={open} size="small">
      <Dialog.Header>Reject bid</Dialog.Header>
      <Dialog.Body>
        <Layout.Stack gap="spacing-4">
          I’m rejecting this bid because,
          <RadioGroup onChange={handleChange}>
            {radioValues.map(value => (
              <Radio value={value} key={value}>
                {value}
              </Radio>
            ))}
            {rejectReason === 'Other' && (
              <Layout.Stack gap="spacing-0-5">
                <TextField
                  aria-label="reason"
                  placeholder="Tell us why"
                  name="reason"
                  value={otherReason}
                  max-length={50}
                  onChange={event => {
                    setOtherReason(event.target.value)
                  }}
                />
                <Text variant="body-sm" color="color-text-tertiary">
                  Max 50 characters
                </Text>
              </Layout.Stack>
            )}
          </RadioGroup>
        </Layout.Stack>
      </Dialog.Body>
      <Dialog.Actions>
        <Dialog.ActionSecondary onClick={onCancel}>Cancel</Dialog.ActionSecondary>
        <Dialog.ActionPrimary
          data-testid="confirm-reject-rate"
          onClick={handleConfirm}
          variant="warning"
        >
          Confirm rejection
        </Dialog.ActionPrimary>
      </Dialog.Actions>
    </Dialog>
  )
}

export { ConfirmRejectDialog }
